import _ from 'lodash';
import { axiosInstance } from '../helpers/axios';
import { userService } from './user.service';

export const resourceService = {
  upload,
  findAll,
  findOne,
  update,
  _delete,
  userAction,
  findAllInFolder,
  userFolderAction,
  getStatistics,
};

function upload(userId, files, progressCallback) {
  const formData = new FormData();
  files.forEach(file => {
    formData.append('file', file);
  });

  const requestOptions = {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: e => {
      if (e.total !== 0) {
        progressCallback(parseInt((e.loaded / e.total) * 100, 10));
      }
    },
  };

  const url = userId ? `/users/${userId}/resources` : '/resources';
  return axiosInstance
    .post(url, formData, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function findAll(userId, query) {
  const url = userId ? `/users/${userId}/resources` : '/resources';
  return axiosInstance
    .get(url, { params: query })
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function findOne(id) {
  return axiosInstance
    .get(`/resources/${id}`)
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function update({ id, ...resource }) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: resource,
  };

  return axiosInstance.patch(`/resources/${id}`, requestOptions.body, requestOptions.headers).then(handleResponse);
}

function _delete(userId, resourceId) {
  const url = userId ? `/users/${userId}/resources/${resourceId}` : `/resources/${resourceId}`;
  return axiosInstance
    .delete(url)
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function userAction(userId, resourceId, action) {
  return axiosInstance
    .post(`/users/${userId}/resources/${resourceId}/${action}`)
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function findAllInFolder(userId, folderId, query) {
  return axiosInstance
    .get(`/users/${userId}/resources/folders/${folderId}`, { params: query })
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function userFolderAction(userId, resourceId, folderId, action) {
  return axiosInstance
    .post(`/users/${userId}/resources/${resourceId}/folders/${folderId}/${action}`)
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function getStatistics(latest) {
  return axiosInstance
    .get(`/public/resources/statistics${latest ? '?latest=true' : ''}`)
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

const handleResponse = response => {
  const data = response.data;
  if (!_.includes([200, 201, 204], response.status)) {
    if (response.status === 401) {
      // auto logout if 401 response returned from api
      userService.logout().then(() => window.location.reload(true));
    }

    const error = (data && data.message) || response.statusText;

    // eslint-disable-next-line no-throw-literal
    throw { status: response.status, error };
  }

  return data;
};
